export const getCostPriceBackgroundColor = (
  vendorOrderPrices: any,
  costPrice: number
) => {
  let vendeTotal = 0;
  for (const item of vendorOrderPrices) {
    vendeTotal += item.order_price;
  }

  let costPriceBackgroundColor = '#ffffff'; // 初期値
  if (vendeTotal === 0) {
    costPriceBackgroundColor = '#ffffff';
  } else if (Math.floor(costPrice) >= vendeTotal) {
    costPriceBackgroundColor = '#69b076';
  } else {
    costPriceBackgroundColor = '#f0908d';
  }

  return costPriceBackgroundColor;
};
